import { showError } from '@calendly/alert'
import { useFormContext, useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setIsETEditorSidePanelOpen } from 'features/event_type_editor/slice'
import { useIsValueChanged } from 'hooks/use_is_value_changed'
import { useETEditorFormikPoolingType } from 'services/event_types'

import { AvailabilityCalendarModal } from './availability_calendar_modal'
import { AvailabilityListSidePanel } from './availability_list_side_panel'
import { useAvailabilitySidePanel } from './context'
import { useHasFormErrors } from '../../../../../hooks'

const AutoCloseModal = ({ formPath, closeModal }) => {
  const [{ value: availability }] = useFormField({ name: formPath })
  const { values: { userRuleType } } = useFormContext()

  const { isMultiHost } = useETEditorFormikPoolingType()
  const { usingCustomHours } = availability

  const userRuleTypeChanged = useIsValueChanged(userRuleType)
  const usingCustomHoursChanged = useIsValueChanged(usingCustomHours)

  const isMultihostAvailabilityRuleTypeChanged = isMultiHost && userRuleTypeChanged
  const isPersonalETSwitchedToSchedule = !isMultiHost && usingCustomHoursChanged

  useEffect(() => {
    if (isMultihostAvailabilityRuleTypeChanged || isPersonalETSwitchedToSchedule) {
      closeModal()
    }
  })
}

export const AvailabilitySidePanel = () => {
  const dispatch = useDispatch()
  const { isAvailabilitySidePanelOpen, availabilitySidePanelProps, closeAvailabilitySidePanel } = useAvailabilitySidePanel()
  const { formPath, format, targetRef } = availabilitySidePanelProps
  const hasErrors = useHasFormErrors()

  const handleClose = useCallback(() => {
    if (hasErrors) {
      dispatch(showError(I18n.t('publisher.event_type_editor.sections.errors.section')))
    } else {
      closeAvailabilitySidePanel()
    }
  }, [closeAvailabilitySidePanel, dispatch, hasErrors])

  useEffect(() => {
    if (isAvailabilitySidePanelOpen) {
      dispatch(setIsETEditorSidePanelOpen(true))
    }

    return () => dispatch(setIsETEditorSidePanelOpen(false))
  }, [dispatch, isAvailabilitySidePanelOpen])

  if (!isAvailabilitySidePanelOpen) { return null }

  return (
    <>
      <AutoCloseModal formPath={formPath} closeModal={handleClose} />

      {format === 'calendar' && (
        <AvailabilityCalendarModal
          formPath={formPath}
          onClose={handleClose}
        />
      )}
      {format === 'list' && (
        <AvailabilityListSidePanel
          targetRef={targetRef}
          formPath={formPath}
          onClose={handleClose}
        />
      )}
    </>
  )
}
